import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import Login from "../pages/login/login";
import { Platform, StyleSheet } from "react-native";
import AppConfig from "../config/AppConfig";
import PageWelcome from "../pages/welcome";
import OnboardingAnimPage from "../pages/v3/animation/OnboardingAnimPage";
import PageLoginErr from "../pages/loginerr";
import { RootStack } from "./root-stack";
import EditActivityPage from "../pages/v3/activities/EditActivityPage";
import EditSetPage from "../pages/v3/activities/groups/EditSetPage";
import EditTagPage from "../pages/v3/tags/EditTagPage";
import TagActivitiesPage from "../pages/v3/tags/tag-activities/TagActivitiesPage";
import SurveyPage from "../pages/v3/survey/SurveyPage";
import AppointmentPage from "../pages/v3/appointment/AppointmentPage";
import ProfilePage from "../pages/v3/more/ProfilePage";
import OnboardingInfoPage from "../pages/v3/animation/info/OnboardingInfoPage";
import PageOffline from "../pages/offline";
import appPages from "../appPages";
import PageTerms from "../pages/terms";
import PendingLoginPage from "../pages/login/PendingLoginPage";
import CustomizeElementsPage from "../pages/v3/elements/CustomizeElementsPage";
import IntegrationsMappingGame from "../pages/v3/integrations/mapping/IntegrationsMappingGame";
import IntegrationsMappingPage from "../pages/v3/integrations/mapping/IntegrationsMappingPage";
import IntegrationsMappingDone from "../pages/v3/integrations/mapping/IntegrationsMappingDone";
import IntegrationsDeletePage from "../pages/v3/integrations/IntegrationsDeletePage";
import IntegrationRulesPage from "../pages/v3/integrations/IntegrationRulesPage";
import IntegrationsHistoryPage from "../pages/v3/integrations/IntegrationsHistoryPage";
import ScheduleTimePage from "../pages/v3/more/ScheduleTimePage";
import IntegrationsPageV2 from "../pages/v3/integrations/IntegrationsPageV2";
import IntegrationsOnboardingPage from "../pages/v3/integrations/onboarding/IntegrationsOnboardingPage";
import ComparisonPage from "../pages/v3/reflection/comparison/ComparisonPage";
import TimerElementPicker from "../pages/v3/home/cards/timer/TimerElementPicker";
import ReportCommentsPage from "../pages/v3/reports/discussion/ReportCommentsPage";

const styles = StyleSheet.create({
  scene: Platform.select({
    web: {
      width: "100%",
      maxWidth: AppConfig.MAX_WIDTH,
      margin: "auto",
      flex: 1,
    },
  }),
});

const Stack = createStackNavigator();

export function AuthStack(props) {
  const pages = props.pages;
  const { ResolutionDetailPage, EditElementPage } = pages;

  return (
    <Stack.Navigator
      initialRouteName={appPages.welcome}
      sceneContainerStyle={styles.scene}
      screenOptions={{ headerShown: false, header: () => null }}
    >
      <Stack.Screen
        name={appPages.welcome}
        options={{ gestureEnabled: false, title: "Mana" }}
      >
        {(p) => (
          <PageWelcome
            {...p}
            controller={props.controller}
            isLoggedIn={props.isLoggedIn}
          />
        )}
      </Stack.Screen>
      <Stack.Screen
        name="login"
        options={{ gestureEnabled: false, title: "Mana" }}
      >
        {(p) => <Login {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen name="error" options={{ title: "Mana" }}>
        {(p) => <PageLoginErr {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen name="offline" options={{ title: "Mana" }}>
        {(p) => <PageOffline {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen
        name={appPages.onboardingPage}
        options={{ gestureEnabled: false, title: "Mana" }}
      >
        {(p) => <OnboardingAnimPage {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen
        name={appPages.onboardingInfoPage}
        options={{ gestureEnabled: false, title: "Mana - Onboarding" }}
      >
        {(p) => <OnboardingInfoPage {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen
        name={appPages.terms}
        options={{ gestureEnabled: false, title: "Mana" }}
      >
        {(p) => <PageTerms {...p} controller={props.controller} />}
      </Stack.Screen>

      <Stack.Screen name="mana" options={{ title: "Mana" }}>
        {(p) => (
          <RootStack {...p} controller={props.controller} pages={pages} />
        )}
      </Stack.Screen>

      <Stack.Screen name="home_page" options={{ title: "Home" }}>
        {(p) => <pages.HomePage {...p} controller={props.controller} />}
      </Stack.Screen>

      <Stack.Screen name={appPages.resolutionPage} options={{ title: "Goals" }}>
        {(p) => <pages.ResolutionPage {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen name="goal" options={{ title: "Mana" }}>
        {(p) => <ResolutionDetailPage {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen name="gem" options={{ title: "Mana" }}>
        {(p) => (
          <pages.ReflectionEditPage {...p} controller={props.controller} />
        )}
      </Stack.Screen>

      <Stack.Screen name="gems" options={{ title: "Mana" }}>
        {(p) => (
          <pages.ResolutionGemsPage {...p} controller={props.controller} />
        )}
      </Stack.Screen>
      <Stack.Screen name="element" options={{ title: "Mana" }}>
        {(p) => <EditActivityPage {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen name="set" options={{ title: "Mana" }}>
        {(p) => <EditSetPage {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen name="tag" options={{ title: "Mana" }}>
        {(p) => <EditTagPage {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen name="tags" options={{ title: "Mana" }}>
        {(p) => <TagActivitiesPage {...p} controller={props.controller} />}
      </Stack.Screen>

      <Stack.Screen name="get_started" options={{ title: "Mana" }}>
        {(p) => <pages.GetStartedPage {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen name="routines" options={{ title: "Mana" }}>
        {(p) => <pages.RoutinesPage {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen name="edit_routine" options={{ title: "Mana" }}>
        {(p) => <pages.EditRoutinePage {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen name="survey" options={{ title: "Mana" }}>
        {(p) => <SurveyPage {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen name="knowledge_base" options={{ title: "Mana" }}>
        {(p) => (
          <pages.KnowledgeBasePage {...p} controller={props.controller} />
        )}
      </Stack.Screen>
      <Stack.Screen name="appointment" options={{ title: "Mana" }}>
        {(p) => <AppointmentPage {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen name="settings" options={{ title: "Mana" }}>
        {(p) => <pages.SettingsPage {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen
        name={appPages.integrationsOnboarding}
        options={{ title: "Mana" }}
      >
        {(p) => (
          <IntegrationsOnboardingPage {...p} controller={props.controller} />
        )}
      </Stack.Screen>

      {/* Integrations */}
      <Stack.Screen name={appPages.integrationsV2} options={{ title: "Mana" }}>
        {(p) => <IntegrationsPageV2 {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen
        name={appPages.integrationsMappingGame}
        options={{ title: "Mana - Integrations Mapping Game" }}
      >
        {(p) => (
          <IntegrationsMappingGame {...p} controller={props.controller} />
        )}
      </Stack.Screen>
      <Stack.Screen
        name={appPages.integrationsMappingDone}
        options={{ title: "Mana - Integrations Mapping Done" }}
      >
        {(p) => (
          <IntegrationsMappingDone {...p} controller={props.controller} />
        )}
      </Stack.Screen>

      <Stack.Screen
        name={appPages.integrationsMappingPage}
        options={{ title: "Mana - Integrations Mapping Page" }}
      >
        {(p) => (
          <IntegrationsMappingPage {...p} controller={props.controller} />
        )}
      </Stack.Screen>
      <Stack.Screen
        name={appPages.integrationsDeletePage}
        options={{ title: "Mana - Integrations Delete Page" }}
      >
        {(p) => (
          <IntegrationsDeletePage
            {...p}
            controller={props.controller}
            templateName={"Delete"}
          />
        )}
      </Stack.Screen>
      <Stack.Screen
        name={appPages.integrationsIgnorePage}
        options={{ title: "Mana - Integrations Ignore Page" }}
      >
        {(p) => (
          <IntegrationsDeletePage
            {...p}
            controller={props.controller}
            templateName={"Ignore"}
          />
        )}
      </Stack.Screen>
      <Stack.Screen
        name={appPages.integrationRulesPage}
        options={{ title: "Mana - Integrations Ignore Page" }}
      >
        {(p) => <IntegrationRulesPage {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen
        name={appPages.integrationsHistoryPage}
        options={{ title: "Mana - Integrations History Page" }}
      >
        {(p) => (
          <IntegrationsHistoryPage {...p} controller={props.controller} />
        )}
      </Stack.Screen>
      <Stack.Screen
        name={appPages.integrationsDesktopSync}
        options={{ title: "Integrations - Desktop Sync" }}
      >
        {(p) => <pages.DesktopSyncPage {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen
        name={appPages.integrationsCalendar}
        options={{ title: "Integrations - Calendar" }}
      >
        {(p) => <pages.CalendarSyncPage {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen
        name={appPages.integrationsOutlook}
        options={{ title: "Integrations - Outlook Calendar" }}
      >
        {(p) => <pages.CalendarSyncPage {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen
        name={appPages.integrationsHealth}
        options={{ title: "Integrations - Health" }}
      >
        {(p) => <pages.HealthSyncPage {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen
        name={appPages.integrationsChrome}
        options={{ title: "Integrations - Chrome" }}
      >
        {(p) => <pages.ChromeSyncPage {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen
        name={appPages.integrationsSlack}
        options={{ title: "Integrations - Slack" }}
      >
        {(p) => <pages.SlackSyncPage {...p} controller={props.controller} />}
      </Stack.Screen>
      {/* End Integrations */}

      <Stack.Screen name="invite_friends" options={{ title: "Mana" }}>
        {(p) => (
          <pages.InviteFriendsPage {...p} controller={props.controller} />
        )}
      </Stack.Screen>
      <Stack.Screen name={appPages.testingPage} options={{ title: "Mana" }}>
        {(p) => <pages.TestingPage {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen
        name={appPages.scheduleTimePage}
        options={{ title: "Mana" }}
      >
        {(p) => <ScheduleTimePage {...p} controller={props.controller} />}
      </Stack.Screen>

      <Stack.Screen
        name={appPages.coachingRoom}
        options={{ title: "Mana - Coaching Room" }}
      >
        {(p) => <pages.CoachingRoomPage {...p} controller={props.controller} />}
      </Stack.Screen>

      <Stack.Screen name={appPages.enabledUsers} options={{ title: "Users" }}>
        {(p) => <pages.EnabledUsersPage {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen name="impersonate" options={{ title: "Mana" }}>
        {(p) => <pages.ImpersonatePage {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen name="animation" options={{ title: "Mana" }}>
        {(p) => <OnboardingAnimPage {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen name="profile" options={{ title: "Mana" }}>
        {(p) => <ProfilePage {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen name="help" options={{ title: "Mana" }}>
        {(p) => <pages.HelpPage {...p} controller={props.controller} />}
      </Stack.Screen>

      <Stack.Screen name="average_week" options={{ title: "Mana" }}>
        {(p) => (
          <pages.LastWeekPage
            {...p}
            templateName={"Onboarding"}
            controller={props.controller}
          />
        )}
      </Stack.Screen>
      <Stack.Screen name="average_template" options={{ title: "Mana" }}>
        {(p) => (
          <pages.LastWeekPage
            {...p}
            templateName={"AutoTrack"}
            controller={props.controller}
          />
        )}
      </Stack.Screen>

      <Stack.Screen name="pay" options={{ title: "Mana" }}>
        {(p) => <pages.PaymentsPage {...p} controller={props.controller} />}
      </Stack.Screen>

      <Stack.Screen
        name={appPages.editElement}
        options={{ title: "Mana - Edit Elements" }}
      >
        {(p) => <EditElementPage {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen name="share_element" options={{ title: "Mana" }}>
        {(p) => <pages.ShareElementPage {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen
        name={appPages.archiveElementsPage}
        options={{ title: "Mana" }}
      >
        {(p) => (
          <pages.ArchiveElementsPage {...p} controller={props.controller} />
        )}
      </Stack.Screen>

      <Stack.Screen
        name={appPages.customizeElementsPage}
        options={{ title: "Mana" }}
      >
        {(p) => <CustomizeElementsPage {...p} controller={props.controller} />}
      </Stack.Screen>

      <Stack.Screen name={appPages.pendingLogin} options={{ title: "Mana" }}>
        {(p) => <PendingLoginPage {...p} controller={props.controller} />}
      </Stack.Screen>

      <Stack.Screen name={appPages.reflectionPage} options={{ title: "Mana" }}>
        {(p) => (
          <pages.ReflectionPage
            {...p}
            controller={props.controller}
            useElements={true}
          />
        )}
      </Stack.Screen>
      <Stack.Screen name={appPages.comparisonPage} options={{ title: "Mana" }}>
        {(p) => <ComparisonPage {...p} controller={props.controller} />}
      </Stack.Screen>

      <Stack.Screen name={appPages.trackHome} options={{ title: "Mana" }}>
        {(p) => <pages.TrackHomePage {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen name={appPages.trackDetail} options={{ title: "Mana" }}>
        {(p) => <pages.TrackDetailsPage {...p} controller={props.controller} />}
      </Stack.Screen>

      <Stack.Screen name="dashboard" options={{ title: "Mana" }}>
        {(p) => <pages.DashboardPage {...p} controller={props.controller} />}
      </Stack.Screen>

      {/* Reports */}
      <Stack.Screen
        name={appPages.reportsPage}
        options={{ title: "Mana - Reports" }}
      >
        {(p) => (
          <pages.ReportsPage
            {...p}
            controller={props.controller}
            isEditMode={true}
          />
        )}
      </Stack.Screen>
      <Stack.Screen
        name="view_report"
        options={{ title: "Mana - View Report" }}
        isEditMode={false}
      >
        {(p) => <pages.ReportsPage {...p} controller={props.controller} />}
      </Stack.Screen>
      <Stack.Screen
        name={appPages.sentReports}
        options={{ title: "Mana - Sent Reports" }}
      >
        {(p) => (
          <pages.MyReportsPage
            {...p}
            controller={props.controller}
            type={"sent"}
          />
        )}
      </Stack.Screen>
      <Stack.Screen
        name={appPages.receivedReports}
        options={{ title: "Mana - Received Reports" }}
      >
        {(p) => (
          <pages.MyReportsPage
            {...p}
            controller={props.controller}
            type={"received"}
          />
        )}
      </Stack.Screen>
      <Stack.Screen
        name={appPages.receivedAggregatedReports}
        options={{ title: "Mana - Received Reports" }}
      >
        {(p) => (
          <pages.MyReportsPage
            {...p}
            controller={props.controller}
            type={"aggregated"}
          />
        )}
      </Stack.Screen>
      <Stack.Screen
        name={appPages.reportComments}
        options={{ title: "Mana - Discussion" }}
      >
        {(p) => <ReportCommentsPage {...p} controller={props.controller} />}
      </Stack.Screen>
      {/* End reports */}

      <Stack.Screen name="snoozed_cards" options={{ title: "Snoozed Cards" }}>
        {(p) => <pages.SnoozedCardsPage {...p} controller={props.controller} />}
      </Stack.Screen>

      {/* Elements */}
      <Stack.Screen
        name={appPages.elementsPage}
        options={{ title: "Elements" }}
      >
        {(p) => <pages.ElementsPage {...p} controller={props.controller} />}
      </Stack.Screen>

      {/* Timer Element Picker */}
      <Stack.Screen
        name={appPages.timerElementsPage}
        options={{ title: "Timer Elements" }}
      >
        {(p) => <TimerElementPicker {...p} controller={props.controller} />}
      </Stack.Screen>
    </Stack.Navigator>
  );
}
